export const RegisterType = 
    [ 
        {
            "id": "1",
            "type": "Individual",
        },
        {
            "id": "2",
            "type": "Bulk Registrations",
        },
        {
            "id": "3",
            "type": "College/University"
        },
        {
            "id": "4",
            "type": "C-DAC ACTS Student"
        },
        {
            "id": "5",
            "type": "C-DAC Employee"
        },
        {
            "id": "6",
            "type": "Corporate Users"
        },
        {
            "id": "7",
            "type": "APSSDC Student"
        }
];